<template lang="pug">
IndexOriginal
</template>

<script setup>
import { onMounted } from 'vue'

import { useMainStore } from '@/stores/main'
import { storage } from '@/utils/storage'

definePageMeta({
  middleware: 'guest',
})

const config = useRuntimeConfig()
const { setModal } = useMainStore()

onMounted(() => {
  const token = storage.get(`cuora_${config.public.clientId}`)
  if (!token) {
    setModal('ModalPanelSignUp')
  }
})
</script>

<style lang="scss" scoped></style>
